/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Newsletter - Scroll to it after submit
if (window.location.href.indexOf('?customer_posted=true') > -1) {
    setTimeout(() => {
        document.querySelector('.newsletter-form').scrollIntoView()
    }, 750)
}

// Fix for product list items inside offcanvas mobile menu
document.querySelectorAll('#offcanvas-menu-upsell-collection .btn-atc').forEach(($btn) => {
    $btn.addEventListener('click', () => {
        const offcanvas = bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-mobile-menu')
        offcanvas.hide()
    })
})

/*
    Navbar menu items open on hover (not click)
*/
document.querySelectorAll('#navbar .navbar-nav .nav-link.dropdown-toggle').forEach(($item) => {
    $item.addEventListener('mouseenter', () => {
        document.querySelectorAll('#navbar .navbar-nav .nav-link.dropdown-toggle').forEach(($item) => {
            $item.classList.remove('show')
            $item.setAttribute('aria-expaned', 'false')
            $item.nextElementSibling.classList.remove('show')
        })

        $item.classList.add('show')
        $item.setAttribute('aria-expaned', 'true')
        $item.nextElementSibling.classList.add('show')
        $item.nextElementSibling.setAttribute('data-bs-popper', 'none')
    })
    $item.addEventListener('mouseleave', () => {
        if (!$item.nextElementSibling.matches(':hover')) {
            $item.classList.remove('show')
            $item.setAttribute('aria-expaned', 'false')
            $item.nextElementSibling.classList.remove('show')
        }
    })

    $item.addEventListener('click', (e) => {
        window.location.href = $item.getAttribute('href')
    })
})
document.querySelector('#main').addEventListener('mouseenter', () => {
    document.querySelectorAll('#navbar .navbar-nav .nav-link.dropdown-toggle').forEach(($item) => {
        $item.classList.remove('show')
        $item.setAttribute('aria-expaned', 'false')
        $item.nextElementSibling.classList.remove('show')
    })
})

// Handle Plus/Minus in quantity steppers
window.qtyDecrease = (btn) => {
    const input = btn.closest('.quantity-wrapper').querySelector('input')
    const inputValue = Number(input.value)

    if (inputValue > 1) {
        input.value = inputValue - 1
    }
}
window.qtyIncrease = (btn) => {
    const input = btn.closest('.quantity-wrapper').querySelector('input')
    const inputValue = Number(input.value)

    input.value = inputValue + 1
}
// Offcanvas wishlist - Open it if URL contains '#wishlist'
// if (window.location.hash.includes('#wishlist')) {
//     const offcanvasWishlist = bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-wishlist')
//     offcanvasWishlist.show()
// }

// OrderGrove fix link styling on the account page
// const orderGroveLink = document.querySelector('.ordergrove-account-link .btn')

// if (orderGroveLink) {
//     orderGroveLink.classList.add('btn-outline-primary', 'mt-5')
// }

// OrderGroove "My Subscriptiosn" page style fixes
// document.querySelectorAll('.page-width').forEach(($el) => {
//     $el.classList.add('container', 'my-10')
// })

// Recharge subscrptions page - Add back to account link
const rechargePageWrapper = document.querySelector('body#recharge-novum #recharge-te')

if (rechargePageWrapper) {
    rechargePageWrapper.insertAdjacentHTML('beforeend', `
        <p class="mt-7 text-center">
            <a href="/account" class="btn btn-outline-primary px-4 py-2">← Go back to account</a>
        </p>
    `)
}

// Gorgias chat - widget adjustments on various occasions
document.querySelectorAll('.offcanvas').forEach(offcanvas => {
    offcanvas.addEventListener('show.bs.offcanvas', () => {
        if (GorgiasChat) {
            GorgiasChat.hideOnMobile(true)
        }
    })
})

document.querySelectorAll('.offcanvas').forEach(offcanvas => {
    offcanvas.addEventListener('hide.bs.offcanvas', () => {
        if (GorgiasChat) {
            GorgiasChat.hideOnMobile(false)
        }
    })
});

// YouTube with video in product pages
(() => {
    const modalEl = document.querySelector('#youtube-with-modal')

    if (!modalEl) {
        return
    }

    let player

    modalEl.addEventListener('show.bs.modal', () => {
        player = new YT.Player('youtube-with-modal-player', {
            videoId: modalEl.dataset.videoId,
            playerVars: {
                playsinline: 1
            },
            events: {
                onReady: onPlayerReady
            }
        })

        function onPlayerReady(event) {
            player.playVideo()
        }
    })

    modalEl.addEventListener('hide.bs.modal', () => {
        player.pauseVideo()
    })
})();


// Mp4 with video in product pages
(() => {
    const modalEl = document.querySelector('#mp4-with-modal')

    if (!modalEl) {
        return
    }

    let player

    modalEl.addEventListener('show.bs.modal', () => {
        modalEl.querySelector('video').play()
    })

    modalEl.addEventListener('hide.bs.modal', () => {
        modalEl.querySelector('video').pause()
    })
})();
